import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Constantes } from '../../../compartido/constantes/constantes';
import { AsociacionPersonaDTO } from '../../../compartido/modelado-compartido/asociacionPersonaDTO';
import { MensajesConstantes } from '../../../compartido/constantes/mensajes';
import { MessageService, TreeNode } from 'primeng/primeng';
import { Subscription } from 'rxjs';
import { AsociacionJefeDependenciaService, CateringUnidadService, TipoPersonaService } from 'npm-servicios-catering';
import { Unidad } from "modelo-unidad-servicio-sga";
import { environment } from '../../../../environments/environment';
import { Persona } from '../../../compartido/modelado-compartido/persona';
import { AsociacionPersona, TipoPersona } from 'npm-modelado-catering';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { Usuario } from '../../modelado/sar/usuario';
import { UnidadAdministrativa } from '../../modelado/sar/unidad-administrativa';
import { UsuarioRolesXRolDto } from '../../modelado/sar/usuario-roles-x-rol-dto';
import { UsuarioXRolXUnidadDTO } from '../../modelado/sar/usuario-x-rol-x-unidad-DTO';
import { UsuarioXRolXUnidad } from '../../modelado/sar/usuario-x-rol-x-unidad';
import { Rol } from '../../modelado/sar/rol';
@Component({
  selector: 'app-agregar-jefe-dependencia',
  templateUrl: './agregar-jefe-dependencia.component.html',
  styleUrls: ['./agregar-jefe-dependencia.component.css']
})
export class AgregarJefeDependenciaComponent extends LoadingPage implements OnInit {


  @Input() jefeUnidadEditar: AsociacionPersonaDTO;
  @Output() resultado = new EventEmitter();

  tempString: String = "";
  asociacionPersonaRecuperada: AsociacionPersonaDTO = {};
  lstRespuesta: String[];
  tipoP: TipoPersona = {};
  unidadSeleccionada: Unidad;
  personaGuardar: AsociacionPersona = {};
  personaRecuperada: Persona;
  identificacionRecuperada: String;
  identificacionBusquedaPersona: String;
  nombresPersona: string;
  correoPersona: String;
  lstUnidad: any;
  jefeUnidadNuevo: AsociacionPersonaDTO = {};
  busy: Subscription;
  tituloPagina: string;
  idAsociacionPersona: number = -1;
  nuevaAsociacionPersona: boolean;
  deshabilitaBusqueda: boolean;
  loadingBusqueda: boolean;
  textoBusquedaUnidad: string = "";
  lstPersonasResultados: Persona[];
  lstPersonasResultadosAdministrativos: Persona[];
  lstPersonasResultadosDocentes: Persona[];
  selectedPersonaBusqueda: Persona;
  selectedPersona: Persona;
  mostrandoBuscarPersona: boolean;
  flagEncuentraPersona: boolean = false;
  guardaDesactiva: boolean = false;
  

  usuarioGAS: Usuario;//usuario para el micro del gas

  // ===============  Nodos para Unidad ===========
  lstNodosUnidades: TreeNode[];
  selectedNodosUnidad: TreeNode; //Son los nodos seleccionados para la unidad
  guardarNodosUnidad: UnidadAdministrativa[] = []; //Son los nodos para guardar

  lista: UnidadAdministrativa[];

  // === Almacena los roles del aplicativo ===
  lstRolesAplicativo: Rol[] = [];
  objRolSeleccionado: Rol = new Rol();

  unidadAux: UnidadAdministrativa[] = [];

  /**
   * es la lista de roles del usuario y aplicativo
   */
  listaUsuarioXRol: UsuarioXRolXUnidad[] = [];

  dependenciaYaAsignada: boolean = false;

  constructor(private routeParams: ActivatedRoute, private router: Router, private mensajes: MensajesConstantes, private messageService: MessageService
    , private asociacionJefeDependenciaService: AsociacionJefeDependenciaService, private cateringUnidadService: CateringUnidadService,
    private datosSesionService: DatosSesionService,
    private confirmationService: ConfirmationService, private tipoPersonaService: TipoPersonaService) {
    super(false);
  }

  ngOnInit() {

    this.nuevaAsociacionPersona = false;
    if (this.routeParams.snapshot.params['idAsociacionPersona']) {
      this.idAsociacionPersona = this.routeParams.snapshot.params['idAsociacionPersona'];
      this.tituloPagina = this._editar;
    } else {
      this.idAsociacionPersona = -1;
      this.tituloPagina = this._nuevoJefeDependencia;
      this.nuevaAsociacionPersona = true;
    }

    this.cargarEnviroment();

    if (this.idAsociacionPersona !== -1) {
      this.deshabilitaBusqueda = true;
      this.obtenerAsociacionPersonaPorId();
    } else {
      this.deshabilitaBusqueda = false;
      this.obtenerUnidades();
    }
  }

  regresar() {
    //this.dignidadNueva = {};
    this.router.navigateByUrl(Constantes.URL_ASOCIAR_JEFE_DEPENDENCIA);
  }
  cancelarAgregarJefeDependencia() {
    this.redirectListado();
  }
  obtenerAsociacionPersonaPorId() {
    this.busy = this.asociacionJefeDependenciaService.buscarByIdAsociacionPersona(this.idAsociacionPersona).then(asociacionPersona => {
      if (asociacionPersona) {
        this.asociacionPersonaRecuperada = asociacionPersona;
        this.nombresPersona = this.asociacionPersonaRecuperada.nombrePersona;
        this.correoPersona = this.asociacionPersonaRecuperada.correo;
        this.identificacionBusquedaPersona = this.asociacionPersonaRecuperada.idPersona;
        this.obtenerUnidades();
        //        this.seleccionarTipoUnidad();
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  seleccionarTipoUnidad() {
    console.log(this.lstUnidad.length);
    if (this.lstUnidad) {
      console.log("existe");

    }
  }

  asignaElRolyUnidad() {

    console.log(this.selectedNodosUnidad);
    if (!this.selectedNodosUnidad) {
      this.mostrarMensajeAdvertencia('NO EXISTE UNIDADES SELECCIONADAS SELECCIONELAS O USE QUITAR EL ROL');
      return;
    }

    this.standby();

    let objDTO: UsuarioXRolXUnidadDTO = new UsuarioXRolXUnidadDTO();

    let objUxRxU: UsuarioXRolXUnidad = new UsuarioXRolXUnidad();
    objUxRxU.idRol = environment.ROL_JEFE_DEPENDENCIA_ID;
    objUxRxU.estaActivo = true;
    objUxRxU.unidadAdministrativa = null;
    objUxRxU.idAplicativo = environment.APP_ID;
    objUxRxU.usuario = this.usuarioGAS;

    objDTO.usuarioXRolXUnidad = objUxRxU;

    /**
     * Agrego a la lista del DTO las unidades seleccionadas 
     */
    //this.guardarNodosUnidad
    for (let index = 0; index < this.guardarNodosUnidad.length; index++) {
      //const objUnidadSeleccionada: TreeNode = this.guardarNodosUnidad[index];
      objDTO.unidades.push(this.guardarNodosUnidad[index]);
      console.log("Push");
    }

    console.log('va mandar con unidade4s ' + objDTO.unidades.length);
    this.standby();

    const urlUsuarioXRolXUnidad = environment.URL_USUARIOXROLXUNIDAD;
    this.asociacionJefeDependenciaService.crearConUnidad(urlUsuarioXRolXUnidad, objDTO).then(
      resp => {
        let obj: UsuarioXRolXUnidadDTO;
        obj = resp;
        this.ready();
        this.mostrarMensajeInfo('SE REGISTRO CORRECTAMENTE EL ROL CON LA(s) ' + objDTO.unidades.length + ' UNIDAD(es)');
      }, error => {
        this.ready();
        this.mostrarMensajeError(error);
        //rollback eliminamos lo creado
        this.personaGuardar.idDependencia = this.selectedNodosUnidad.data.idUnidad + "";
        this.personaGuardar.idPersona = this.personaRecuperada.idPersona;
        this.personaGuardar.estaActivo = "N";
        this.tipoP.idTipoPersona = 1;
        this.personaGuardar.tipoPersona = this.tipoP;
        this.personaGuardar.estaActivoParaDependencia = "S";
        this.asociacionJefeDependenciaService.crear(this.personaGuardar).then(asociacion => {
          if (asociacion) {
            this.mostrarMensajeInfo('NO SE REGISTRO CORRECTAMENTE INTENTE NUEVAMENTE O MÁS TARDE REFRESCANDO LA PÁGINA');
            this.redirectListadoExito(true);

          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });

      }
    );


  }

  verificarSiYaEstaAsociada() {
    this.dependenciaYaAsignada = false;
    if (this.listaUsuarioXRol) {
      for (let index = 0; index < this.listaUsuarioXRol.length; index++) {
        console.log("Ingresa x");
        const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRol[index];

        if (objUsuaraioXRol.idRol == environment.ROL_JEFE_DEPENDENCIA_ID) {

          console.log('muestra usuario x rol ' + index + " " + objUsuaraioXRol.unidadAdministrativa.nombre);
          if (this.selectedNodosUnidad) {

            console.log(this.selectedNodosUnidad.data.idUnidad);

            /*console.log(this.unidadAux.nombre);*/
            if (objUsuaraioXRol.unidadAdministrativa.idUnidad == this.selectedNodosUnidad.data.idUnidad) {

              this.dependenciaYaAsignada = true;
              return;
            }
          } else {
            this.mostrarMensajeAdvertencia('DEBE SELECCIONAR UNA DEPENDENCIA');
          }


        }
      }
    }
  }

  cargaNodosParaGuardar() {
    for (let index = 0; index < this.listaUsuarioXRol.length; index++) {
      console.log("Ingresa x");
      const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRol[index];

      if (objUsuaraioXRol.idRol == environment.ROL_JEFE_DEPENDENCIA_ID) {
        this.guardarNodosUnidad.push(objUsuaraioXRol.unidadAdministrativa);
      }
    }
  }

  async guardarJefeDependencia() {

    if (this.usuarioGAS != null) {
      if (this.selectedNodosUnidad) {
        console.log("Ingresa");
        await this.verificarSiYaEstaAsociada();
        console.log("Sale");
        if (!this.dependenciaYaAsignada) {
          this.guardaDesactiva = true;
          await this.cargaNodosParaGuardar();
          this.guardarNodosUnidad.push(this.selectedNodosUnidad.data);


          this.asociacionJefeDependenciaService.buscarSiDependenciaEstaActivaYEstaActivaParaDependencia(this.selectedNodosUnidad.data.idUnidad + "").then(existe => {
            if (existe) {
              this.lstRespuesta = [];
              this.lstRespuesta = existe;
              if (this.lstRespuesta[0].localeCompare("1") == 0) {//si existe la dependencia pero no esta activa para la dependencia
                this.personaGuardar.idDependencia = this.selectedNodosUnidad.data.idUnidad + "";
                this.personaGuardar.idPersona = this.personaRecuperada.idPersona;
                this.personaGuardar.estaActivo = "S";
                this.tipoP.idTipoPersona = 1;
                this.personaGuardar.tipoPersona = this.tipoP;
                this.personaGuardar.estaActivoParaDependencia = "S";
                this.asociacionJefeDependenciaService.crear(this.personaGuardar).then(asociacion => {
                  if (asociacion) {
                    this.asignaElRolyUnidad();
                    this.redirectListadoExito(true);
                  }
                }).catch(error => {
                  this.mostrarMensajeError(error);
                });
              } else {
                if (this.lstRespuesta[0].localeCompare("0") == 0) {//si no existe la dependencia pero no esta activa para la dependencia
                  this.personaGuardar.idDependencia = this.selectedNodosUnidad.data.idUnidad + "";
                  this.personaGuardar.idPersona = this.personaRecuperada.idPersona;
                  this.personaGuardar.estaActivo = "S";
                  this.tipoP.idTipoPersona = 1;
                  this.personaGuardar.tipoPersona = this.tipoP;
                  this.personaGuardar.estaActivoParaDependencia = "S";
                  this.asociacionJefeDependenciaService.crear(this.personaGuardar).then(asociacion => {
                    if (asociacion) {
                      this.asignaElRolyUnidad();
                      this.redirectListadoExito(true);
                    }
                  }).catch(error => {
                    this.mostrarMensajeError(error);
                  });
                } else {
                  if (this.lstRespuesta[0].localeCompare("2") == 0) {//si existe la dependencia y esta activa para la dependencia
                    this.confirmationService.confirm({
                      key: 'autorizacion',
                      header: 'Crear Jefe Dependencia Inactivo',
                      message: 'Ya hay una persona asociada a la dependencia ¿Desea crear en estado inactivo?',
                      accept: () => {
                        this.personaGuardar.idDependencia = this.selectedNodosUnidad.data.idUnidad + "";
                        this.personaGuardar.idPersona = this.personaRecuperada.idPersona;
                        this.personaGuardar.estaActivo = "S";
                        this.tipoP.idTipoPersona = 1;
                        this.personaGuardar.tipoPersona = this.tipoP;
                        this.personaGuardar.estaActivoParaDependencia = "N";
                        this.asociacionJefeDependenciaService.crear(this.personaGuardar).then(asociacion => {
                          if (asociacion) {
                            //this.asignaElRolyUnidad(); cuando crea en esta inactivo no se asocia la unidad al rol
                            this.redirectListadoExito(true);
                          }
                        }).catch(error => {
                          this.mostrarMensajeError(error);
                        });
                      }
                    });
                  }
                }
              }
            } else {
              console.log("No se encuentra");
            }
          }).catch(error => {
            this.mostrarMensajeError(error);
          });


        } else {
          this.mostrarMensajeError('LA PERSONA YÁ ESTA ASOCIADA A ESTA DEPENDENCIA');
        }
      } else {
        this.mostrarMensajeAdvertencia('DEBE SELECCIONAR UNA DEPENDENCIA');
      }
    } else {
      this.mostrarMensajeAdvertencia('DEBE SELECCIONAR UNA PERSONA');
    }






  }
  obtenerUnidades() {
    const urlUnidad = environment.URL_UNIDAD;
    this.busy = this.cateringUnidadService.listarUnidadServicio(urlUnidad).then(unidades => {
      if (unidades) {
        this.lstUnidad = unidades;
        if (this.idAsociacionPersona !== -1) {
          for (const tipoUnidad of this.lstUnidad) {
            this.tempString = tipoUnidad.idUnidad + "";
            if (this.tempString.localeCompare(this.asociacionPersonaRecuperada.idUnidad) == 0) {
              this.unidadSeleccionada = tipoUnidad;
              break;
            }
          }
        }
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar dependencias, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });

    this.listarNodoArbolPorIdUnidadRaiz(0).then(
      respuesta => {
        this.lstNodosUnidades = respuesta.children;
      }
    ).catch(error => console.error('ERROR en la promesa listarNodoArbolPorIdUnidadRaiz ', error));


  }
  buscarPersonaPorIdentificacion() {

    if (this.identificacionBusquedaPersona) {
      const urlPersona = environment.URL_PERSONA;
      this.busy = this.asociacionJefeDependenciaService.buscarPorId(urlPersona, this.identificacionBusquedaPersona).then(persona => {
        if (persona) {
          this.personaRecuperada = persona;
          this.correoPersona = this.personaRecuperada.correoInstitucional;

          this.nombresPersona = "";
          if (this.personaRecuperada.nombrePrimero.length > 2) {
            this.nombresPersona = this.nombresPersona + this.personaRecuperada.nombrePrimero;
          }
          if (this.personaRecuperada.nombreSegundo.length > 2) {
            this.nombresPersona = this.nombresPersona + " " + this.personaRecuperada.nombreSegundo;
          }
          if (this.personaRecuperada.apellidoPrimero.length > 2) {
            this.nombresPersona = this.nombresPersona + " " + this.personaRecuperada.apellidoPrimero;
          }
          if (this.personaRecuperada.apellidoSegundo.length > 2) {
            this.nombresPersona = this.nombresPersona + " " + this.personaRecuperada.apellidoSegundo;
          }
          this.identificacionRecuperada = this.personaRecuperada.identificacion;

        } else {
          console.log("No se encuentra");
          this.mostrarMensajeInfo("No se encuentra una persona con la identificación ingresada");
          this.nombresPersona = "";
          this.correoPersona = "";
        }
      }).catch(error => {
        this.mostrarMensajeError(error);
      });
    }

  }

  validarCamposAlmacenar(): boolean {
    try {
      let resultado = true;
      let mensajeError = "Error por favor revisar";

      //Valida el tipo de espacio fisico
      if (!this.unidadSeleccionada) {
        mensajeError += this._saltoLineaDetalle + this._dependenciaRequerida;
        resultado = false;
      }
      if (!this.nombresPersona) {
        mensajeError += this._saltoLineaDetalle + this._personaRequerida;
        resultado = false;
      }
      if (!resultado) {
        this.mostrarMensajeError(mensajeError);
      }
      return resultado;
    } catch (error) {
      console.error("ERROR. ValidarCamposAlmacenar", error);
      return false;
    }
  }
  redirectListado() {
    this.router.navigate(['/espacios-fisicos/listado']);
    this.router.navigate(['/configuracion/asociar-jefe-dependencia/']);
  }

  redirectListadoExito(exito: boolean) {
    this.guardaDesactiva = false;
    this.datosSesionService.exitoGuardandoJefeUnidad = exito;
    this.router.navigate(['/configuracion/asociar-jefe-dependencia/']);
  }
  cargarEnviroment() {
    this.asociacionJefeDependenciaService.set_constantes(Constantes);
    this.tipoPersonaService.set_constantes(Constantes);
  }
  construirNombre(personaRecuperada) {
    console.log("construyendo nombre")

    if (personaRecuperada.apellidoPrimero != null) {
      if (personaRecuperada.apellidoPrimero.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.apellidoPrimero;
      }
    }
    if (personaRecuperada.apellidoSegundo != null) {
      if (personaRecuperada.apellidoSegundo.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.apellidoSegundo;
      }
    }
    if (personaRecuperada.nombrePrimero != null) {
      if (personaRecuperada.nombrePrimero.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.nombrePrimero;
      }
    }
    if (personaRecuperada.nombreSegundo != null) {
      if (personaRecuperada.nombreSegundo.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.nombreSegundo;
      }
    }


  }
  clickBuscarPersonaClaseCriterio() {
    if (this.textoBusquedaUnidad.trim().length > 0) {
      const urlPersona = environment.URL_PERSONA;
      this.lstPersonasResultados = undefined;
      let textoBusquedaUnidadtmp = this.textoBusquedaUnidad;

      if (!Constantes.caracteresRegex.test(textoBusquedaUnidadtmp)) {
        this.mostrarMensajeError(this._nosePermitenCaracteresEspeciales);
        return;
      } else {
        this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "ADMINISTRATIVO", this.textoBusquedaUnidad).then(responseBusqueda => {
          this.mensaje = [];
          this.lstPersonasResultados = responseBusqueda;

          this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "DOCENTE", this.textoBusquedaUnidad).then(responseBusqueda => {
            this.lstPersonasResultadosDocentes = responseBusqueda;
            this.lstPersonasResultadosDocentes.forEach(async docente => {
              this.flagEncuentraPersona = false;
              await this.buscaPersonaIgual(docente);
              if (!this.flagEncuentraPersona) {
                this.lstPersonasResultados.push(docente);
              }
            });

            this.loadingBusqueda = false;
          }).catch(error => {
            this.loadingBusqueda = false;
            this.mostrarMensajeError(error);
          });
          this.loadingBusqueda = false;
        }).catch(error => {
          this.loadingBusqueda = false;
          this.mostrarMensajeError(error);
        });
      }
      this.loadingBusqueda = true;

    } else {
      this.mostrarMensajeError("Debe ingresar el número de cédula o los nombres de la persona a buscar");
    }
  }
  buscaPersonaIgual(docente) {
    this.lstPersonasResultados.forEach(async administrativo => {
      if (docente.identificacion == administrativo.identificacion) {
        this.flagEncuentraPersona = true;
      }
    });
  }

  /*seleccionaElUsuarioParaAsociar(){
    for (var h=0;h<this.usuarioGAS.length;h++){
      console.log( "to com"+ this.usuarioGAS[h].nombre.substring(0,this.usuarioGAS[h].nombre.indexOf(" ")));
      console.log( "other"+ (this.usuarioGAS[h].ldapUid.substring(0,this.usuarioGAS[h].ldapUid.indexOf(".")-1)));
      if (this.usuarioGAS[h].nombre.substring(0,this.usuarioGAS[h].nombre.indexOf(" ")).toLowerCase().localeCompare(this.usuarioGAS[h].ldapUid.substring(0,this.usuarioGAS[h].ldapUid.indexOf(".")).toLowerCase())==0){
        console.log("iguales");
        this.posArrayUsuarioAsociar=h;        
      }
    }
  }*/

  async clickSeleccionarPersona() {
    if (this.selectedPersonaBusqueda.correoInstitucional != null) {
      //console.log(this.selectedPersonaBusqueda.correoInstitucional + " email");

      if (this.selectedPersonaBusqueda.correoInstitucional.localeCompare("No Definido") != 0) {


        const urlUsuario = environment.URL_USUARIO;
        this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.selectedPersonaBusqueda.correoInstitucional.substring(0, this.selectedPersonaBusqueda.correoInstitucional.indexOf("@"))).then(async responseU => {
          if (responseU) {
            console.log(responseU);
            this.usuarioGAS = responseU;

            console.log("persona GAS " + this.usuarioGAS.idUsuario);

            //await this.seleccionaElUsuarioParaAsociar();

            const URL_USUARIOXROLXUNIDAD = environment.URL_USUARIOXROLXUNIDAD;
            this.cateringUnidadService.buscarPorIdAplicativoPorIdUsuario(URL_USUARIOXROLXUNIDAD, environment.APP_ID, this.usuarioGAS.idUsuario).then(
              async resp => {
                console.log(0 + " pos array asociar");
                this.ready();
                this.listaUsuarioXRol = resp;
                console.log(this.listaUsuarioXRol.length + " tamaño lista por usuario por rol");

                this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
                this.personaRecuperada = Object.assign({}, this.selectedPersonaBusqueda);
                this.mostrandoBuscarPersona = false;
                this.nombresPersona = ""
                await this.construirNombre(this.selectedPersonaBusqueda);
                this.mostrarMensajeInfo("Se ha seleccionado correctamente");

              }, error => {
                console.error(error);
                this.ready();
              }
            );


          } else {

            this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });

      } else {
        this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
        await this.construirNombre(this.selectedPersonaBusqueda);
        this.mostrarMensajeInfo("La persona seleccionada no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");

        this.mostrandoBuscarPersona = true;
      }
    } else {
      this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
      await this.construirNombre(this.selectedPersonaBusqueda);
      this.mostrarMensajeInfo("La persona seleccionada no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");
      this.mostrandoBuscarPersona = true;
    }
  }
  clickMostrarBuscarPersona() {
    this.mostrandoBuscarPersona = true;
  }
  clickOcultarBuscarPersona() {
    this.mostrandoBuscarPersona = false;
  }


  listarNodoArbolPorIdUnidadRaiz(idUnidadRaiz: number): Promise<TreeNode> {

    console.log('INGRESA listarTodoMenusPorAplicativoMenuTreeNode -->' + idUnidadRaiz);
    let promesa = new Promise((resolve, reject) => {


      console.log('INGRESA promesa');

      let itemRetorna: TreeNode;

      const urlUnidadAdministrativa = environment.URL_UNIDADADMINISTRATIVA;
      this.cateringUnidadService.listarNodoArbolPorIdUnidadRaiz(urlUnidadAdministrativa, idUnidadRaiz).then(
        respuesta => {
          this.lista = respuesta;

          if (this.lista) {

            let objMenuPrincipal: UnidadAdministrativa = new UnidadAdministrativa();
            objMenuPrincipal.nombre = 'MENU PRINCIPAL';
            // Encapsula en un menu principal
            for (let index = 0; index < this.lista.length; index++) {
              const menu = this.lista[index];
              objMenuPrincipal.hijos.push(menu);
            }

            let root = <TreeNode>{
            };
            root.children = [];

            this.funCargarNodossPrime(root, objMenuPrincipal);


            itemRetorna = root;

            resolve(itemRetorna);
          }



        }
      ).catch(error => console.error('ERROR en la promesa listarNodoArbolPorIdUnidadRaiz ', error));

    });
    return promesa;
  }







  /**
   * Permite cargar a nodos prime
   * @param nodoRaiz 
   * @param objUnidadAdministrativa 
   */
  private funCargarNodossPrime(nodoRaiz: any, objUnidadAdministrativa: UnidadAdministrativa): TreeNode {

    let lstHijos: UnidadAdministrativa[] = objUnidadAdministrativa.hijos;
    if (lstHijos != null && lstHijos.length > 0) {
      for (let index = 0; index < lstHijos.length; index++) {
        const objHijo = lstHijos[index];

        if (objHijo.hijos != null && objHijo.hijos.length > 0) {
          let nodoHijo = <TreeNode>{};
          nodoHijo.label = objHijo.nombre;


          let datos = UnidadAdministrativa.clonar(objHijo);
          datos.hijos = null;
          nodoHijo.data = datos;

          nodoHijo.expanded = false;
          nodoHijo.children = [];
          let nodoLlega = this.funCargarNodossPrime(nodoHijo, objHijo);
          nodoRaiz.children.push(nodoLlega);
        } else {
          let nodoHijo = <TreeNode>{};
          nodoHijo.children = [];
          nodoHijo.label = objHijo.nombre;
          nodoHijo.expanded = true;
          nodoHijo.data = objHijo;
          nodoRaiz.children.push(nodoHijo);
        }
      }
    }
    return nodoRaiz;
  }

  /*private cargarListaSeleccionadaPlana(elementosNodo: TreeNode[], objSel: UnidadAdministrativa) {
    try {

      if (objSel != null) {

        let encuentra = false;
        for (let index = 0; index < elementosNodo.length; index++) {
          const elementoNodo: TreeNode = elementosNodo[index];
          console.log('manda a buscar sobre nodo ' + elementoNodo.label);
          const objData: UnidadAdministrativa = elementoNodo.data;
          if (objData.idUnidad == objSel.idUnidad) {
            this.selectedNodosUnidad.push(elementoNodo);
            encuentra = true;
            return;
          }
        }

        if (encuentra == false) {
          for (let index = 0; index < elementosNodo.length; index++) {
            const elementoNodo: TreeNode = elementosNodo[index];
            const objData: UnidadAdministrativa = elementoNodo.data;
            this.cargarListaSeleccionadaPlana(elementoNodo.children, objSel);
          }
        }

      }


    } catch (error) {
      console.error('ERROR  cargarListaSeleccionadaPlana Detalle:...', error);
    }
  }*/

}
